export const getUrnWithTwoColons = (id: string) => {
  // Incoming id only has a single colon, we need two to match BE
  const splitValues = atob(id).split(":");
  return `${splitValues[0]}::${splitValues[1]}`;
};
